import { GraduationServicePath } from "utils/constants";
import permissions from "app/permissions";
import AddGroupExam from "./Create";

export const resources = {
  isMenu: false,
  name: GraduationServicePath + "state-exams-group-add/:id",
  title: "Добавяне на групов държавен изпит",
  create: <AddGroupExam />,
  permission: permissions.canCreateGroupStateExams,
};
